export const NewsSearchGeneralTypes = {
  NEWS_SEARCH_GENERAL: 'NEWS_SEARCH_GENERAL',
  NEWS_SEARCH_GENERAL_LAST_SEARCH: 'NEWS_SEARCH_GENERAL_LAST_SEARCH',
};
